import { __assign, __rest } from "tslib";
import React from "react";
export function indentable(options) {
    var _a = options.indent, indent = _a === void 0 ? 20 : _a, relations = options.relations, targetColumnKey = options.targetColumnKey;
    return {
        getInfo: function () { return ({ name: "indentable" }); },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            // 不是目标列
            if (!targetColumnKey || column.key !== targetColumnKey) {
                return previous(record, rowKey, recordIndex, column, columnIndex);
            }
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), preChildren = _a.children, props = _a.props, result = __rest(_a, ["children", "props"]);
            var children = preChildren;
            // 非表头
            if (recordIndex !== -1) {
                var paddingLeft = 0;
                var depth = 0;
                if (indent > 0) {
                    var node = rowKey;
                    while (relations && relations[node]) {
                        depth += 1;
                        node = relations[node];
                    }
                    paddingLeft = indent * depth;
                }
                children = React.createElement("div", { style: { paddingLeft: paddingLeft } }, children);
            }
            return __assign(__assign({}, result), { props: props, children: children });
        }; },
    };
}
//# sourceMappingURL=indentable.js.map